const currency_schema = {
   data:{
       base:"",
       date:"",
       rates: {}
   },
    isCall:false
};

export default currency_schema;


// WEBPACK FOOTER //
// ./src/service/schema/currency-scema.js